export const getForecastLimit = (intervalMaxJ) => {
  if (intervalMaxJ === null || intervalMaxJ === undefined) return null;

  const nowInFrance = new Date(
    new Date().toLocaleString("en-US", { timeZone: "Europe/Paris" }),
  );
  const limit = new Date(
    nowInFrance.getFullYear(),
    nowInFrance.getMonth(),
    nowInFrance.getDate(),
    nowInFrance.getHours(),
  );
  limit.setDate(limit.getDate() + intervalMaxJ);
  // Hourly forecast steps: the last valid step is (now + N days) - 1h,
  limit.setHours(limit.getHours() - 1);
  return limit;
};

// Date-only part of the forecast limit — this is the last calendar
// date the date-picker should allow selecting at all.
export const getForecastLimitDateOnly = (intervalMaxJ) => {
  const limit = getForecastLimit(intervalMaxJ);
  if (!limit) return null;
  return new Date(limit.getFullYear(), limit.getMonth(), limit.getDate());
};

export const getMaxHourForDate = (dateObj, intervalMaxJ) => {
  const forecastLimit = getForecastLimit(intervalMaxJ);
  if (!forecastLimit || !dateObj) return 23;

  const selectedDate = new Date(
    parseInt(dateObj.year, 10),
    parseInt(dateObj.month, 10) - 1,
    parseInt(dateObj.day, 10),
  );
  const limitDateOnly = new Date(
    forecastLimit.getFullYear(),
    forecastLimit.getMonth(),
    forecastLimit.getDate(),
  );

  if (selectedDate.getTime() === limitDateOnly.getTime()) {
    return forecastLimit.getHours();
  }
  if (selectedDate.getTime() > limitDateOnly.getTime()) return -1;
  return 23;
};